export default "__VITE_ASSET__CauVPGbe__"